export default __webpack_public_path__ + "static/media/PRAZOHECT-5.eb265323.jpg";